module.exports = __webpack_public_path__ + "static/mail-406f2ffcfb5478556df1eae81601e0c5.png";